import { useParams, useNavigate, useLocation } from "react-router-dom";

const OrderSuccess = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 optional: support orderCode passed from checkout
  const orderCode = location.state?.orderCode;

  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <h2>🎉 Order Placed Successfully</h2>

      <h3>Order ID:</h3>

      {/* 🔥 show readable order code first, fallback to id */}
      <h1 style={{ color: "green" }}>
        {orderCode || orderId}
      </h1>

      <p style={{ marginTop: "10px", color: "#555" }}>
        {orderCode ? "Your order is confirmed" : "Payment completed successfully"}
      </p>

      <button
        onClick={() =>
          navigate(`/user/track-order/${orderCode || orderId}`)
        }
      >
        Track Order
      </button>

      <button
        onClick={() => navigate("/shop")}
        style={{ marginLeft: "10px" }}
      >
        Continue Shopping
      </button>
    </div>
  );
};

export default OrderSuccess;